import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Byline from './byline'
import NavTop from './navtop'
import ScrollDown from './scrolldown'
import {
  pubdateString,
  moddateString,
} from './component-helpers/datehelpers'
import * as topperStyles from '../../styles/modules/topper.module.less'
import WCMImage from './wcmimage'
import { GetBylineText } from './component-helpers/getbylinetext'
let story_settings = require('../../data/story_settings.sheet.json')[0]
const Topper = ({ meta, pageContext, url_add = ''}) => {
  const {
    PROJECT: { AUTHORS, ISO_MODDATE, ISO_PUBDATE, DISPLAY_TITLE, DECK },
  } = meta
  let socialHTML = `
      <div class=${topperStyles.socialIcon}>
        <a
          title="Share via email"
          href="mailto:?subject=${meta.PROJECT.TITLE}&body=${meta.PROJECT.DESCRIPTION}%0A%0A${meta.MAIN_DOMAIN}%2F${meta.PROJECT.SUBFOLDER}%2F${meta.PROJECT.SLUG}%2F${url_add}%2F">
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.00977 5.83789C3.00977 5.28561 3.45748 4.83789 4.00977 4.83789H20C20.5523 4.83789 21 5.28561 21 5.83789V17.1621C21 18.2667 20.1046 19.1621 19 19.1621H5C3.89543 19.1621 3 18.2667 3 17.1621V6.16211C3 6.11449 3.00333 6.06765 3.00977 6.0218V5.83789ZM5 8.06165V17.1621H19V8.06199L14.1215 12.9405C12.9499 14.1121 11.0504 14.1121 9.87885 12.9405L5 8.06165ZM6.57232 6.80554H17.428L12.7073 11.5263C12.3168 11.9168 11.6836 11.9168 11.2931 11.5263L6.57232 6.80554Z"
              fill="currentColor"
            />
          </svg>
        </a>
      </div>
      <div class=${topperStyles.socialIcon}>
        <a
          title="Share on Facebook"
          href="https://www.facebook.com/sharer/sharer.php?u=${meta.MAIN_DOMAIN}%2F${meta.PROJECT.SUBFOLDER}%2F${meta.PROJECT.SLUG}%2F${url_add}%2F"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.19795 21.5H13.198V13.4901H16.8021L17.198 9.50977H13.198V7.5C13.198 6.94772 13.6457 6.5 14.198 6.5H17.198V2.5H14.198C11.4365 2.5 9.19795 4.73858 9.19795 7.5V9.50977H7.19795L6.80206 13.4901H9.19795V21.5Z"
              fill="currentColor"
            />
          </svg>
        </a>
      </div>
      <div class=${topperStyles.socialIcon}>
        <a
          target="_blank"
          rel="noopener noreferrer"
          title="Share on Twitter"
          href="https://twitter.com/intent/tweet?url=${meta.MAIN_DOMAIN}%2F${meta.PROJECT.SUBFOLDER}%2F${meta.PROJECT.SLUG}%2F${url_add}%2F&text=${meta.PROJECT.TWITTER_TEXT}">
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 248 204" 
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
      <path
        data-name="Twitter Logo"
        fill="currentColor"
        d="M222 51.29c.15 2.16.15 4.34.15 6.52 0 66.74-50.8 143.69-143.69 143.69A142.91 142.91 0 0 1 1 178.82a102.72 102.72 0 0 0 12 .72 101.29 101.29 0 0 0 62.72-21.66 50.53 50.53 0 0 1-47.18-35.07 50.35 50.35 0 0 0 22.8-.86 50.53 50.53 0 0 1-40.52-49.5v-.64a50.25 50.25 0 0 0 22.92 6.32 50.55 50.55 0 0 1-15.6-67.42 143.38 143.38 0 0 0 104.08 52.77 50.55 50.55 0 0 1 86.06-46.06 101.19 101.19 0 0 0 32.06-12.26 50.66 50.66 0 0 1-22.2 27.93 100.89 100.89 0 0 0 29-7.94A102.84 102.84 0 0 1 222 51.29z"
      />
      </svg>
        </a>
      </div>`
  function convertDatesToAP(dateString) {
    // Convert date string to AP style abbreviations
    let newDateString = dateString
    newDateString = newDateString
      .replace('January', 'Jan.')
      .replace('February', 'Feb.')
      .replace('August', 'Aug.')
      .replace('September', 'Sept.')
      .replace('October', 'Oct.')
      .replace('November', 'Nov.')
      .replace('December', 'Dec.')
      .replace('AM', 'a.m.')
      .replace('PM', 'p.m.')
    // Return the result
    return newDateString
  }
  const parseDate = (date) => {
    let parts = date.match(/(\d+)/g)
    let dateObject
    console.log(parts)
    dateObject = new Date(parseInt(parts[0]), parseInt(parts[1] - 1), parseInt(parts[2]))
    let month
    try{
    month = convertDatesToAP(new Intl.DateTimeFormat('en-US', {month: 'long'}).format(dateObject))
    }
    catch(error){
      console.log(dateObject)
    }
    let day = dateObject.getDate()
    let year = dateObject.getFullYear()
    return('Week of ' + month + ' ' + day + ', ' + year)
  }
  let hidePageDate = story_settings.Hide_Page_Date === 'TRUE' || story_settings.Hide_Page_Date === true

  return (
    <Fragment>
      <NavTop meta={meta} />
      <header className={topperStyles.header}>
        <section
          aria-label="Topper headline, deck, byline and dateline"
          className={topperStyles.textContainer}
        >
          {story_settings.Kicker && <h2 className={topperStyles.kicker}>{story_settings.Kicker}</h2>}
          <h1 className={topperStyles.hed}>{DISPLAY_TITLE ? DISPLAY_TITLE : "A brave new template v2"}</h1>
          <div className={topperStyles.dateby}>
          {!hidePageDate && <h3>{parseDate(pageContext.Page_Date)}</h3>}
          {story_settings.Byline.length > 0 && <span>By </span>}
          {story_settings.Byline.length > 0 && <span dangerouslySetInnerHTML={{__html: GetBylineText(story_settings.Byline, story_settings.Byline_Link)}}/>}
         
          </div>
          <div className={topperStyles.topsocial}
              dangerouslySetInnerHTML={{__html: socialHTML}}
            />
        </section>
      </header>
    </Fragment>
  )
}

Topper.propTypes = {
  meta: PropTypes.object.isRequired,
}

export default Topper
